/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Hero_Cta2Inputs */

const en_cp_hero_cta2 = /** @type {(inputs: Cp_Hero_Cta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start a team for free`)
};

const id_cp_hero_cta2 = /** @type {(inputs: Cp_Hero_Cta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai tim gratis`)
};

/**
* | output |
* | --- |
* | "Start a team for free" |
*
* @param {Cp_Hero_Cta2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_hero_cta2 = /** @type {((inputs?: Cp_Hero_Cta2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Hero_Cta2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_hero_cta2(inputs)
	return en_cp_hero_cta2(inputs)
});